import LibraryMusicIcon from '@mui/icons-material/LibraryMusic'
import { routeFrontOfficeAllEntityGroupementChainCommon } from '@/lib/routes/front_groupement/common/routeFrontOfficeAllEntityGroupementChainCommon'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

export const routeFrontOfficeGroupementChainSound = [
  ...routeFrontOfficeAllEntityGroupementChainCommon,
  {
    route: 'Audiotheque',
    text: 'Audiothèque',
    t: 'routes.frontoffice.sound.audiotheque',
    href: '/industryoffice/groupement-chain/audiotheque',
    icon: LibraryMusicIcon,
    menuHeader: true,
    position: 12,
  },
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISOUND],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_SOUND_GROUPEMENT_CHAIN_USER],
}))

export default routeFrontOfficeGroupementChainSound
